export default function isSupportAccount(profile = {}) {
  return profile.support === "production" || profile.support === "development";
}
